import { useEffect, useState } from "react";
import "./App.css";
export default function Calculator() {

  const preData = {
    EMR:500,
    EMRS:0.3,
    NFT:20,
    CAL:2000,
    EMRSTEXT:0,
    
  }
  const [data,setData] = useState({});
  const [total, setTotal] = useState(5400);


  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });

  useEffect(() => {
    setData(preData);
  },[]);

  useEffect(() => {
    var temp = parseInt(data.NFT/5);
    var t = (temp * 0.2)+1;

    var caloryMultiplier = data.CAL * t;

    var percentageMultiplier = parseFloat((data.EMR * data.EMRS/100));

    var result = caloryMultiplier * percentageMultiplier;

    setTotal(result);

    
  },[data])


  return (
    <div className="section">
      <div
        style={{
          padding: 20,
          textAlign: "left",
          width: "100%",
        }}
      >
        <div className="mainHeading">

        
          <i
            className="fa-solid fa-border-none"
            style={{
              fontSize: 16,
              marginTop:-3
            }}
          ></i>
          &nbsp;&nbsp;Calculator
        </div>
        <div
          style={{
            marginTop: 20,
          }}
        >
          <div
            style={{
              paddingTop:20,
              padding: 0,
            }}
          >
            <strong
              style={{
                fontSize: 20,
              }}
            >
              Calculate how much money you can earn daily by burning calories.
            </strong>
            <br/>
            <br/>
            <div className="glowBox" style={{
              padding:20
            }}>
            <div className="row">
              <div className="col-sm-12 displayBox">
                <div className="rangeValue">
                  <span id="emrvalue">${data.EMR}</span>/EMR
                </div>
                <span>EMR Price</span>
                <br />
                
                <input
                onInput={(e) => {
                  setData({...data, EMR: e.target.value});
                }}
                  type="range"
                  className="rangeInput"
                  min="0.3"
                  step="0.1"
                  max="1000"
                  value={data.EMR}
                />
                <table>
                  <tr>
                    <td
                      className="defHead"
                      onclick="$('#emrvalue_range').val(0);setRanger();"
                    >
                      0
                    </td>
                    <td
                      className="defHead"
                      onclick="$('#emrvalue_range').val(100);setRanger();"
                    >
                      100
                    </td>
                    <td
                      className="defHead"
                      onclick="$('#emrvalue_range').val(200);setRanger();"
                    >
                      200
                    </td>
                    <td
                      className="defHead"
                      onclick="$('#emrvalue_range').val(300);setRanger();"
                    >
                      300
                    </td>
                    <td
                      className="defHead"
                      onclick="$('#emrvalue_range').val(400);setRanger();"
                    >
                      400
                    </td>
                    <td
                      className="defHead"
                      onclick="$('#emrvalue_range').val(500);setRanger();"
                    >
                      500
                    </td>
                    <td
                      className="defHead"
                      onclick="$('#emrvalue_range').val(600);setRanger();"
                    >
                      600
                    </td>
                    <td
                      className="defHead"
                      onclick="$('#emrvalue_range').val(700);setRanger();"
                    >
                      700
                    </td>
                    <td
                      className="defHead"
                      onclick="$('#emrvalue_range').val(800);setRanger();"
                    >
                      800
                    </td>
                    <td
                      className="defHead"
                      onclick="$('#emrvalue_range').val(900);setRanger();"
                    >
                      900
                    </td>
                    <td
                      className="defHead"
                      onclick="$('#emrvalue_range').val(1000);setRanger();"
                    >
                      1k
                    </td>
                  </tr>
                </table>
              </div>
              <div className="col-sm-12 displayBox">
                <div className="rangeValue">
                  <span>$</span>
                  <span id="emrpercentage">{data.EMRSTEXT}</span>/EMRS
                </div>
                <span>EMRS Price</span>
                
                <br />
                <input onInput={(e) => {
                  var d = parseFloat((data.EMR * e.target.value/100)).toFixed(2);
                  setData({...data, EMRSTEXT: d,EMRS: e.target.value});
                  
                }}
                  type="range"
                  className="rangeInput"
                  id="emrpercentage_range"
                  data-update="emrpercentage"
                  min="0.2"
                  max="0.5"
                  value={data.EMRS}
                  step="0.1"
                  
                />
              </div>
              <div className="col-sm-12 displayBox">
                <div className="rangeValue">
                  <span id="lvlapp">{data.NFT}</span>
                </div>
                <span>NFT LEVEL</span>
                
                <br />
                <input
                 onInput={(e) => {
                  setData({...data, NFT: e.target.value});
                }}
                  type="range"
                  className="rangeInput"
                  min="0"
                  max="100"
                  value={data.NFT}
                  
                  
                />
              </div>
              <div className="col-sm-12 displayBox">
                <div className="rangeValue">
                  <span id="calories">{data.CAL}</span>cal
                </div>
                <span>Daily Burned Calories</span>
                
                <br />
                <input
                 onInput={(e) => {
                  setData({...data, CAL: e.target.value});
                }}
                  type="range"
                  className="rangeInput"
                  min="500"
                  max="10000"
                  step="100"
                  value={data.CAL}
                  
                />
              </div>
              <div className="col-sm-12" >
                <br/>
                <br/>
                <div className="resultBoxTitle">Total Value</div>
                <div className="resultBox">
                  {formatter.format(total)}
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{
        height:500
      }}></div>
    </div>
  );
}
